import {
    FETCH_PREFERENCES_SUCCESS,
    FETCH_PREFERENCES_LOADING
} from "../action/index" 

const defaultState= {
    send_to_voicemail: 1,
    show_notes: 1,
    show_delete: 1,
    forward_calls: 0,
    forward_calls_phones: "",
    is_signature: 0,
    signature_text: "",
    is_loading: true,
}


const preferencesReducer = (state = defaultState, action ) => {
    switch(action.type){
        case FETCH_PREFERENCES_SUCCESS:
            return {...action.payload, is_loading: false}
        case FETCH_PREFERENCES_LOADING:
            return {...defaultState, is_loading: true}
        default:
            return {...state};
    }
}

export default preferencesReducer;